import { Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { DataGrid } from "@mui/x-data-grid";
import * as React from "react";
import useAuth from "../../contexts/UserContext.tsx";
import axiosInstance from "../../Axios.jsx";
import { toast } from "sonner";
import { BeatLoader } from "react-spinners";

export default function TrainingDetailsModal({
  open,
  onClose,
  teacher,
  schoolName,
}) {
  const { user } = useAuth();
  const addModalColumn = [
    {
      field: "crs_id",
      headerName: "Course ID",
    },
    {
      field: "cat_name",
      headerName: "Category",
      minWidth: 180,
    },
    {
      field: "crs_title",
      headerName: "Title",
      minWidth: 250,
    },
    {
      field: "video_usage",
      headerName: "Video Usage (min)",
      minWidth: 180,
      flex: 1,
      renderCell: (params) => (
        <div className="flex justify-center">
          {Intl.NumberFormat("en-US", {
            notation: "compact",
            compactDisplay: "short",
          }).format(params.row.video_usage)}
        </div>
      ),
    },
    {
      field: "excs_usage",
      headerName: "Exercise Usage (min)",
      minWidth: 180,
      flex: 1,
      renderCell: (params) => (
        <div className="flex justify-center">
          {Intl.NumberFormat("en-US", {
            notation: "compact",
            compactDisplay: "short",
          }).format(params.row.excs_usage)}
        </div>
      ),
    },
  ];

  const [courses, setCourses] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    if (teacher !== null) {
      setLoading(true);
      axiosInstance
        .get(
          `getCrsWiseTeacherUsage?auth_token=${user.auth_token}&teacher_name=${teacher.Teacher_Name}`
        )
        .then((res) => {
          setCourses(res.data.data);
        })
        .catch((err) => {
          toast.error("Failed to fetch data");
        })
        .finally(() => {
          setLoading(false);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [teacher]);

  return (
    <>
      <Dialog
        open={open}
        onClose={() => {
          onClose();
          setCourses([]);
        }}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle className="opacity-95">
          <p className="border-b-2 pb-2">Teacher Usage Details</p>
          <div className="text-base mt-2 font-bold">
            {teacher && teacher.Teacher_Name}
          </div>
          <div className="text-sm opacity-60">{schoolName}</div>
        </DialogTitle>
        <DialogContent
          sx={{ display: "flex", gap: 1, flexDirection: "column" }}
        >
          {courses &&
            (courses.length > 0 ? (
              <div className="all-course-container">
                <DataGrid
                  columns={addModalColumn}
                  rows={courses}
                  pageSize={5}
                  rowsPerPageOptions={[5]}
                  pagination
                  rowHeight={50}
                  sx={{ marginTop: "0.5em" }}
                  autoHeight={true}
                  getRowId={(row) => row.crs_id}
                />
              </div>
            ) : (
              <Typography variant="h6" className="text-gray-400">
                {loading && <BeatLoader color="#3B82F6" />}
                {!loading && "No data available"}
              </Typography>
            ))}
        </DialogContent>
      </Dialog>
    </>
  );
}
